import { css } from 'lit';
import { BREAKPOINTS } from '../../../shared/utils/styles/responsive.styles';

export const userAreaStyles = css`
  :host {
    display: inline-block;
    position: relative; /* para posicionar el dropdown */
  }

  .trigger {
    background: none;
    border: 0;
    cursor: pointer;
    font-family: "CIB Sans Bold";
    font-size: 16px;
    padding: 4px 8px;
  }

  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 9999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #59CBE8;
    color: #2C2A29;
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    text-transform: uppercase;
    font-family: "CIB Sans";
    border: 2px solid #FFFFFF;
  }

  .username {
    display: none;
  }

  .popover {
    position: absolute;
    left: -90px;
    top: calc(100% + 8px);
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,.12);
    padding: 8px;
    min-width: 170px;
    z-index: 20;
  }

  .item {
    width: 100%;
    text-align: left;
    background: none;
    border: 0;
    padding: 8px 10px;
    cursor: pointer;
    font-family: 'Open Sans';
    box-sizing: border-box;
  }
  .item:hover { background: #f6f6f6; }

  @media (min-width: ${BREAKPOINTS.mobileM}px) {
   
  }

  @media (min-width: ${BREAKPOINTS.tabletL}px) {
    .username {
      display: block;
    }
    .popover {
      right: 0;
    }
  }
  @media (min-width: ${BREAKPOINTS.desktopXS}px) {
  }
`;
